//--------------------------
// get characteristic prefix
//--------------------------
export default function getCharacteristicPrefixes() {
  let char_array = ['str','con','dex','siz','int','pow','cha']
  return char_array
}
